/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { CORE_STRINGS } from '../../Constants/Strings.constants';
import { ERROR_SCREEN_TYPES } from './DxpErrorScreen.constants';
import { ErrorScreen } from './elements/ErrorScreen/ErrorScreen';
import { ErrorScreenProps } from './elements/ErrorScreen/ErrorScreen.props';

/**
 * DXP Console Error Screen.
 * Helper component to determine error type for the `<ErrorScreen />` component.
 */
export const DxpErrorScreen = (): JSX.Element => {
  const location = useLocation();
  const errorType = new URLSearchParams(location.search).get(`type`) || ERROR_SCREEN_TYPES.unknownError;

  let errorMessage = ``;
  let errorExplanation = ``;
  let showButton = true;

  switch (errorType) {
    case ERROR_SCREEN_TYPES.unknownError:
      errorMessage = CORE_STRINGS.errorUnknown;
      errorExplanation = CORE_STRINGS.errorUnknownDetail;
      showButton = false;
      break;
    case ERROR_SCREEN_TYPES.idpError:
      errorMessage = CORE_STRINGS.errorIdp;
      errorExplanation = CORE_STRINGS.errorIdpDetail;
      break;
    case ERROR_SCREEN_TYPES.unauthorizedError:
      errorMessage = CORE_STRINGS.errorUnauthorised;
      errorExplanation = CORE_STRINGS.errorUnauthorisedDetail;
      break;
    case ERROR_SCREEN_TYPES.noPageAccessError:
      errorMessage = CORE_STRINGS.noPageAccess;
      break;
    default:
      errorMessage = `${errorType.toUpperCase()} ${CORE_STRINGS.error}`;
      break;
  }

  const errorScreenProps: ErrorScreenProps = {
    explanation: errorExplanation,
    message: errorMessage,
    showButton,
  };

  return <ErrorScreen {...errorScreenProps} />;
};
